function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement, isValidElement } from "react";
import { media } from "sprout-ui-theme";
import { ItemType } from "sprout-graphql";
import { Text, Flex, Box } from "sprout-ui-primitives";
import memoDownshiftProps from "sprout-ui-dom/dist/memoDownshiftProps";
import { SelectableWrapper } from "sprout-ui-dom/dist/Selectables";
import styled from "styled-components";
import { ACTIONS } from "@sprout/list-navigation";
import { CardLink, CardContent } from "../Card";
import Avatar from "../Avatar";
import ItemImage from "../ItemImage";
const JumpToItemWrapper = styled(SelectableWrapper)`
  position: relative;
`;
const JumpToItemKeybinding = styled(Box)`
  display: none;

  ${media.up("medium", "pointer")} {
    display: initial;
  }
`;
const StyledText = styled(Text)`
  ${media.target("touch")} {
    font-size: 16px;
  }
`;
const JumpToItem = (props)=>{
    const { action , label , url , type , image , context , icon: iconProp , user  } = props, rest = _objectWithoutProperties(props, [
        "action",
        "label",
        "url",
        "type",
        "image",
        "context",
        "icon",
        "user"
    ]);
    const icon = iconProp ? /*#__PURE__*/ isValidElement(iconProp) ? iconProp : /*#__PURE__*/ createElement(iconProp) : undefined;
    const actionSpec = action && ACTIONS.find((a)=>a.command === action);
    return /*#__PURE__*/ _jsxs(JumpToItemWrapper, _objectSpread({
        as: "li",
        height: "52px"
    }, rest, {
        children: [
            url && /*#__PURE__*/ _jsx(CardLink, {
                to: url
            }),
            /*#__PURE__*/ _jsxs(CardContent, {
                as: Flex,
                alignItems: "center",
                color: "white.100",
                flex: "1",
                minWidth: "0",
                children: [
                    type === ItemType.Post && /*#__PURE__*/ _jsx(ItemImage, {
                        size: 24,
                        type: type,
                        src: image,
                        children: !image && icon
                    }),
                    user && /*#__PURE__*/ _jsx(Avatar, {
                        user: user,
                        size: 24
                    }),
                    type !== ItemType.Post && icon && /*#__PURE__*/ _jsx(Flex, {
                        width: "24px",
                        height: "24px",
                        alignItems: "center",
                        justifyContent: "center",
                        children: icon
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        flex: "1",
                        minWidth: "0",
                        ml: "16px",
                        children: [
                            context && /*#__PURE__*/ _jsx(Text, {
                                fontSize: 0,
                                truncate: true,
                                mb: "4px",
                                lineHeight: "normal",
                                color: "white.87",
                                children: context
                            }),
                            /*#__PURE__*/ _jsx(StyledText, {
                                fontSize: "15px",
                                truncate: true,
                                fontWeight: type === ItemType.Post ? "regular" : "medium",
                                lineHeight: "normal",
                                children: label
                            })
                        ]
                    }),
                    actionSpec && /*#__PURE__*/ _jsx(JumpToItemKeybinding, {
                        lineHeight: "20px",
                        px: 0,
                        bg: "white.12",
                        fontWeight: "bold",
                        fontSize: "13px",
                        borderRadius: "4px",
                        color: "white.70",
                        as: "span",
                        children: actionSpec.keybindingForDisplay
                    })
                ]
            })
        ]
    }));
};
export default memoDownshiftProps(JumpToItem);
